import { HAZWOPER_OPTIONS, type RegistrationExtendedFormValues } from "@buxus/shared";
import { RegReqLabel } from "../../ui/RegReqLabel";

type Props = {
  extendedForm: RegistrationExtendedFormValues;
  hazwoperError?: string;
  showHazwoperError: boolean;
  onPatch: (partial: Partial<RegistrationExtendedFormValues>) => void;
  onHazwoperBlur: () => void;
};

export function AgencyTrainingStep({
  extendedForm,
  hazwoperError,
  showHazwoperError,
  onPatch,
  onHazwoperBlur,
}: Props) {
  const toggleBool = (key: keyof Pick<
    RegistrationExtendedFormValues,
    | "naturalGasNfpa329"
    | "hazardousMaterials"
    | "hazardousLiquids"
    | "highlyVolatileLiquids"
    | "pipelineEmergencies"
    | "incidentCommand"
    | "nationalIncidentManagementSystem"
    | "dotEmergencyResponseGuide"
    | "emergencyMedicalTechnician"
  >) => {
    onPatch({ [key]: !extendedForm[key] } as Partial<RegistrationExtendedFormValues>);
  };

  return (
    <>
      <h2 className="reg-step-title">Agency Training</h2>
      <p className="reg-step-lead">Specific training on:</p>
      <div className="reg-grid">
        <label className="reg-field">
          <RegReqLabel required>HAZMAT</RegReqLabel>
          <select
            value={extendedForm.hazwoper}
            onChange={(e) => onPatch({ hazwoper: e.target.value })}
            onBlur={onHazwoperBlur}
          >
            <option value="">Select</option>
            {HAZWOPER_OPTIONS.map((o) => (
              <option key={o} value={o}>
                {o}
              </option>
            ))}
          </select>
          {showHazwoperError && hazwoperError ? (
            <small className="reg-field-error">{hazwoperError}</small>
          ) : null}
        </label>
      </div>
      <div className="reg-checkbox-stack">
        <label className="reg-checkbox-label">
          <input
            type="checkbox"
            checked={extendedForm.naturalGasNfpa329}
            onChange={() => toggleBool("naturalGasNfpa329")}
          />
          <span>Natural Gas (NFPA 329)</span>
        </label>
        <label className="reg-checkbox-label">
          <input
            type="checkbox"
            checked={extendedForm.hazardousMaterials}
            onChange={() => toggleBool("hazardousMaterials")}
          />
          <span>Hazardous Materials / Weapons of Mass Destruction</span>
        </label>
        <label className="reg-checkbox-label">
          <input
            type="checkbox"
            checked={extendedForm.hazardousLiquids}
            onChange={() => toggleBool("hazardousLiquids")}
          />
          <span>Hazardous liquids</span>
        </label>
        <label className="reg-checkbox-label">
          <input
            type="checkbox"
            checked={extendedForm.highlyVolatileLiquids}
            onChange={() => toggleBool("highlyVolatileLiquids")}
          />
          <span>Highly volatile liquids</span>
        </label>
        <label className="reg-checkbox-label">
          <input
            type="checkbox"
            checked={extendedForm.pipelineEmergencies}
            onChange={() => toggleBool("pipelineEmergencies")}
          />
          <span>Pipeline Emergencies</span>
        </label>
        <label className="reg-checkbox-label">
          <input
            type="checkbox"
            checked={extendedForm.incidentCommand}
            onChange={() => toggleBool("incidentCommand")}
          />
          <span>Incident Command</span>
        </label>
        <label className="reg-checkbox-label">
          <input
            type="checkbox"
            checked={extendedForm.nationalIncidentManagementSystem}
            onChange={() => toggleBool("nationalIncidentManagementSystem")}
          />
          <span>National Incident Management System</span>
        </label>
        <label className="reg-checkbox-label">
          <input
            type="checkbox"
            checked={extendedForm.dotEmergencyResponseGuide}
            onChange={() => toggleBool("dotEmergencyResponseGuide")}
          />
          <span>DOT Emergency Response Guide</span>
        </label>
        <label className="reg-checkbox-label">
          <input
            type="checkbox"
            checked={extendedForm.emergencyMedicalTechnician}
            onChange={() => toggleBool("emergencyMedicalTechnician")}
          />
          <span>Emergency Medical Technician</span>
        </label>
      </div>
    </>
  );
}
